<template>
  <div class="ma3 ma4-l lh-copy">
    <div class="mb4 mw7 tl avenir">
      <h1 class="ma0 pa0 fw5 f4 f3-l">{{ description }}</h1>
    </div>

    <div>
      <a v-for="(resource, index) in resources" :key="index"
        :href="resource.url"
        target="_blank"
        class="link mv2 pa0 text-primary underline f5 f4-l db"
      >
      {{ resource.title }}
      </a>
    </div>

    <div class="mt5 f6 f5-l">
      <h1 class="section-hd">
        Центральный офис (адрес разработки)
      </h1>
      г. Долгопрудный, проспект Пацаева, д. 7, корп. 1, оф. 43.<br>
      Прием клиентов не осуществляется.
    </div>

    <div class="mt4 f6 f5-l">
      <h1 class="section-hd">
        Реквизиты
      </h1>
      <div class="props-layout">
        <span>Адрес</span><span>141707, Россия, Московская обл., г. Долгопрудный, пр-кт Пацаева, д. 7, корп. 1, оф. 43</span>
        <span>ИНН</span><span>5008041569</span>
        <span>КПП</span><span>500801001</span>
        <span>ОГРН</span><span>1065047057305</span>
        <span>ОКПО</span><span>96277108</span>
        <span>p/сч.</span><span>40702810840000003808 в ПАО «Сбербанк России» г. Москва</span>
        <span>БИК</span><span>044525225</span>
        <span>к/сч.</span><span>30101810400000000225</span>
        <span>Директор</span><span class="b">Умрихин Олег Викторович</span>
      </div>
    </div>

    <div class="mt4 f6 f5-l">
      <h1 class="section-hd">
        Поддержка
      </h1>
      По вопросам обслуживания клиентов просьба обращаться в Телефонный Центр «ТендерПро-Консультант»: <a href="tel:+79629223781" class="tprolink">+7 (495) 215-14-38</a> (круглосуточно)<br>
      <a href="http://www.tender.pro/callback/" target="_blank" class="tprolink db mv2">Заказать обратный звонок</a>
      <a href="mailto: client@tender.pro" class="tprolink db">client@tender.pro</a>
    </div>

    <div class="mt4 f6 f5-l">
      <h1 class="section-hd">
        Адрес для корреспонденции
      </h1>
      ООО "ТендерПро"<br>
      141707 г. Долгопрудный, МО проспект Пацаева, д. 7, корп. 1, оф. 43<br>
      <span class="mv2 db">
        Контактное лицо: Нагибина Валентина Семеновна, <a href="tel:+74952151438" class="tprolink">+7 (495) 215-14-38</a>, доб 105.<br>
      </span>
      <span class="mv2 db">
        График работы: с понедельника по пятницу с 10:00 до 18:00.
      </span>
      <span class="db b f6">
        Перед доставкой корреспонденции требуется предварительно позвонить не менее чем за 1 час.
      </span>
    </div>

    <div class="mt4 f6 f5-l">
      <h1 class="section-hd">
        Офисы в регионах России
      </h1>
      <div class="props-layout">
        <span>Москва</span><a href="tel:+74952151438" class="tprolink">+7 (495) 215-14-38</a>
        <span>Санкт-Петербург</span><a href="tel:+78127482540" class="tprolink">+7 (812) 748-25-40</a>
        <span>Казань</span><a href="tel:+78432100925" class="tprolink">+7 (843) 210-09-25</a>
        <span>Екатеринбург</span><a href="tel:+73432478304" class="tprolink">+7 (343) 247-83-04</a>
        <span>Воронеж</span><a href="tel:+74733003136" class="tprolink">+7 (473) 300-31-36</a>
        <span>Краснодар</span><a href="tel:+78612018224" class="tprolink">+7 (861) 201-82-24</a>
        <span>Красноярск</span><a href="tel:+73912298083" class="tprolink">+7 (391) 229-80-83</a>
        <span>Нижний Новгород</span><a href="tel:+78312808509" class="tprolink">+7 (831) 280-85-09</a>
        <span>Новосибирск</span><a href="tel:+73832075785" class="tprolink">+7 (383) 207-57-85</a>
        <span>Пермь</span><a href="tel:+73422357837" class="tprolink">+7 (342) 235-78-37</a>
        <span>Ростов-на-Дону</span><a href="tel:+78633032806" class="tprolink">+7 (863) 303-28-06</a>
        <span>Самара</span><a href="tel:+78462129552" class="tprolink">+7 (846) 212-95-52</a>
        <span>Челябинск</span><a href="tel:+73517995610" class="tprolink">+7 (351) 799-56-10</a>
      </div>
    </div>

    <h1 class="ma0 mt4 pa0 b f6 f5-l">
      Представительства
    </h1>

    <div class="mt4 f6 f5-l">
      <h1 class="section-hd">
        КАЗАХСТАН
      </h1>
      100000, Казахстан, г. Караганда, ул. Лободы 9, к. 2<br>
      <a href="tel:+77273507383" class="tprolink db mb2">+7 (727) 350-73-83</a>
      <a href="mailto: kz@tender.pro" class="tprolink db">kz@tender.pro</a>
    </div>

    <div class="mt4 f6 f5-l">
      <h1 class="section-hd">
        УЗБЕКИСТАН
      </h1>
      <a href="tel:+998782079197" class="tprolink db mb2">+998 78 207-91-97</a>
      <a href="mailto: x_tender@umail.uz" class="tprolink db ">x_tender@umail.uz</a>
    </div>

    <div class="mt4 f6 f5-l">
      <h1 class="section-hd">
        Для остальных регионов
      </h1>
      <a href="tel:+88005008412" class="tprolink">8 (800) 500-84-12</a>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  head () {
    return {
      title: 'О системе',
      meta: [{
        hid: 'description',
        name: this.title,
        content: this.description
      }]
    }
  },
  computed: {
    ...mapGetters('about', ['title', 'description', 'address', 'resources'])
  }
}
</script>

<style lang="scss" scoped>
.props-layout {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: .5rem;
  align-items: start;
  justify-items: start;
}
.section-hd {
  margin: 0;
  margin-top: .5rem;
  margin-bottom: .5rem;
  padding: 0;
  font-size: .875rem;
}
@media screen and (min-width: 60em) {
  .props-layout {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 1rem;
    grid-row-gap: .25rem;
    align-items: center;
    justify-items: start;
  }
  .section-hd {
    margin: 0;
    margin-top: .5rem;
    margin-bottom: .5rem;
    padding: 0;
    font-size: 1rem;
  }
}
.tprolink {
  text-decoration: underline;
  color: #334E68;
  font-weight: 500;
}
</style>
